module.exports = __webpack_public_path__ + "img/cover.68a2cb26.png";